"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var canUseDOM_1 = __importDefault(require("@seaweb/coral/utils/canUseDOM"));
function useLastFocus(track) {
    var prevRef = react_1.useRef(!track);
    var isClient = canUseDOM_1.default();
    var lastFocusRef = react_1.useRef(isClient ? document.activeElement : null);
    if (prevRef.current !== track) {
        prevRef.current = track;
        if (isClient && !track) {
            lastFocusRef.current = document.activeElement;
        }
    }
    return lastFocusRef.current;
}
exports.default = useLastFocus;
